import { Component, OnInit, Input } from '@angular/core';
import { UserAccessService } from 'app/shared/services/user-access.service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { Router } from '@angular/router';

@Component({
	selector: 'app-dashboard-residuals-outlook',
	templateUrl: './dashboard-residuals-outlook.component.html',
	styleUrls: ['./dashboard-residuals-outlook.component.scss'],
	host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardResidualsOutlookComponent {
	@Input() title: string;
	@Input() url: string;
	public bindingContext: BindingContext = new BindingContext();
	public kpiData: any;

}
